import { useCallback } from "react";
import { getCsrfHeader } from "../lib/csrf";

const BASE = "/api/admin/impersonation";

export type StartResult = { ok: true } | { ok: false; message: string };

export const useImpersonation = (): {
  start: (email: string) => Promise<StartResult>;
  stop: () => Promise<StartResult>;
} => {
  const start = useCallback(async (email: string): Promise<StartResult> => {
    const res = await fetch(`${BASE}/start`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json", ...getCsrfHeader() },
      body: JSON.stringify({ email }),
    });
    if (res.ok) return { ok: true };
    if (res.status === 400) {
      const body = (await res.json().catch(() => null)) as { message?: string } | null;
      return { ok: false, message: body?.message ?? "Impersonation refused." };
    }
    if (res.status === 403) return { ok: false, message: "Forbidden." };
    return { ok: false, message: `Impersonation failed (${res.status}).` };
  }, []);

  const stop = useCallback(async (): Promise<StartResult> => {
    const res = await fetch(`${BASE}/stop`, {
      method: "POST",
      credentials: "include",
      headers: { ...getCsrfHeader() },
    });
    if (res.ok) return { ok: true };
    return { ok: false, message: `Stop failed (${res.status}).` };
  }, []);

  return { start, stop };
};
